module.exports = __webpack_public_path__ + "img/KF1.35c66851.png";